<template>
  <label class="holder bold p-0 form-check-label" :for="name">
    <div class="row m-0 align-items-center h-100">
      <div class="col-12 p-0 h-100">
        <div class="label">
          <slot/>
        </div>
        <!-- <div class="label">{{label}}</div>
        <input class="form-check-input" :type="type" :name="name" :id="inputId" v-model="inputValue" @change="updateInput" :checked="checked">
        <span class="checkmark"></span> -->
        <input class="form-check-input" type="radio" :name="value" :value="val" @change="updateInput($event.srcElement.checked)" :checked="checked">
        <!-- <label class="form-check-label" :for="name">
          <slot/>
        </label> -->
         <span class="checkmark"></span>
      </div>
    </div>
  </label>

  <!-- <div class="form-check">
    <input class="form-check-input" type="radio" :name="value" :value="val" @change="updateInput($event.srcElement.checked)" :checked="checked">
    <label class="form-check-label" :for="name">
      <slot/>
    </label>
  </div> -->
</template>
<script>
export default {
  name: 'Radio',
  props: ['name', 'val', 'value'],
  data: function () {
    return {
      checked: ''
    }
  },
  mounted () {
    if (this.val === this.value) {
      this.checked = 'checked'
    }
  },
  methods: {
    updateInput (selected) {
      if (selected) {
        this.checked = 'checked'
        this.$emit('input', this.val)
      } else {
        this.checked = 'checked'
        this.$emit('input', '')
      }
    }
  }
}
</script>
<style scoped>
/* Customize the label (the holder) */
.holder {
  display: block;
  position: relative;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 35px;
}
.holder .label {
  padding-left: 40px;
  line-height: 28px;
}
/* Hide the browser's default radio button */
.holder input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  border: 2px solid var(--dark-color-01);
  background-color: var(--light-color-off);
  border-radius: 50%;
  height: 28px;
  width: 28px;
}
.dark-mode .checkmark {
  border: 2px solid var(--light-color-01);
  background-color: var(--dark-color-04);
}
/* When the radio button is checked, add a blue background */
.holder input:checked ~ .checkmark {
  background-color: var(--light-color);
  border: 2px solid var(--primary-color-light);
}
.dark-mode .holder input:checked ~ .checkmark {
  background-color: var(--dark-color);
  border: 2px solid var(--primary-color-dark);
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.holder input:checked ~ .checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.holder .checkmark:after {
  top: 5px;
  left: 5px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: var(--primary-color-light);
  /* left: 0.55rem;
  top: 0.25rem;
  width: 0.5rem;
  height: 0.8rem;
  border: solid var(--primary-color);
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg); */
}
.dark-mode .holder .checkmark:after {
  background-color: var(--primary-color-dark);
}
/* Show the indicator (dot/circle) when checked */
.holder input:checked {
  color: var(--light-color);
}
</style>
